import React from 'react';
import PropTypes from 'prop-types';
import RadioButton from './RadioButton';
import InteractionOutcomeIndicator from '../../interactionOutcome/InteractionOutcomeIndicator';
import styles from './matchInteraction.scss';
import scorableItemNumberingService from '../../../../services/questionView/ScorableItemNumberingService';
import HiddenItemFlagButton from '../../itemFlag/HiddenItemFlagButton';
import settingsReader from '../../../../store/readHelpers/SettingsReader';
import scorableItemReader from '../../../../store/readHelpers/ScorableItemReader';

const AlternativeCell = (props) => {
    const {
        columnChoiceIdentifier,
        correctResponses,
        handleUserResponse,
        isInverted,
        isReadOnly,
        isSelected,
        modelIdentifier,
        rowChoiceIdentifier,
        questionId,
    } = props;
    const addHiddenFocusableFlag = settingsReader.isFlaggingEnabled()
    && scorableItemReader.useNumberPerInteraction();


    const showAnswers = correctResponses !== undefined;
    const classList = [styles.radioButtonWrapper];
    const nameIdentifier = isInverted ? columnChoiceIdentifier : rowChoiceIdentifier;
    const number = scorableItemNumberingService.getInteractionChoiceNumber(questionId, modelIdentifier, nameIdentifier);
    if (isSelected) {
        classList.push(styles.checked);
    }
    if (showAnswers) {
        classList.push(styles.checkAnswers);
    }

    return (
        <td className={classList.join(' ')}>
            <RadioButton
                checked={isSelected}
                columnChoiceIdentifier={columnChoiceIdentifier}
                handleUserResponse={handleUserResponse}
                isInverted={isInverted}
                isReadOnly={isReadOnly}
                modelIdentifier={modelIdentifier}
                rowChoiceIdentifier={rowChoiceIdentifier}
                questionId={questionId}
            />

            { showAnswers &&
                <InteractionOutcomeIndicator
                    answerOption={`${rowChoiceIdentifier} ${columnChoiceIdentifier}`}
                    correctResponses={correctResponses}
                    isAttempted={isSelected}
                    skipUnansweredIndicator
                />
            }
            { addHiddenFocusableFlag &&
            <HiddenItemFlagButton
                orderNumber={number}
                responseIdentifier={nameIdentifier}
                contentRevisionId={questionId}
            />
            }

        </td>
    );
};

AlternativeCell.propTypes = {
    columnChoiceIdentifier: PropTypes.string.isRequired,
    correctResponses: PropTypes.array,
    handleUserResponse: PropTypes.func.isRequired,
    isInverted: PropTypes.bool.isRequired,
    isReadOnly: PropTypes.bool,
    isSelected: PropTypes.bool.isRequired,
    modelIdentifier: PropTypes.string.isRequired,
    rowChoiceIdentifier: PropTypes.string.isRequired,
    questionId: PropTypes.number.isRequired,
};

export default AlternativeCell;
